import { privateAxios } from "@/common/api/axios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseEstablishmentCompaniesWithConsumptionProps<T> = {
  filters?: {
    search?: string;
    stateId?: string;
    cityId?: string;
  };
  mapper?: (data: any) => T,
};

export const useEstablishmentCompaniesWithConsumption = <T,>({
  filters: { search = '', stateId, cityId } = {},
  mapper = Mapper.default<T>(),
}: UseEstablishmentCompaniesWithConsumptionProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['establishmentCompaniesWithConsumption', search, cityId, stateId],
    queryFn: () => {
      return privateAxios.get('/establishment/companies/with_consumption', {
        params: {
          search,
          'q[city_id_eq]': cityId,
          'q[state_id_eq]': stateId,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, isPending, ...rest };
};
